module.exports = __webpack_public_path__ + "static/media/Punjab Public Library.8c04240b.jpeg";